export default {
  baseStyle: {
    border: "2px",
  },
};
